import type { TaskCard, TaskSize } from '@witty-board/shared'

/**
 * Puntos por talla para la suma de la cabecera de columna (CLAUDE.md §6).
 * Escala corta tipo Fibonacci, la convención habitual al planificar con
 * tallas de camiseta (ver docs/DECISIONS.md, fase 3).
 */
export const SIZE_POINTS: Record<TaskSize, number> = {
  XS: 1,
  S: 2,
  M: 3,
  L: 5,
  XL: 8,
}

export function sumSizePoints(tasks: readonly TaskCard[]): number {
  return tasks.reduce((total, task) => total + (task.size ? SIZE_POINTS[task.size] : 0), 0)
}
